import { render, staticRenderFns } from "./Idc.vue?vue&type=template&id=e9946b6e&scoped=true&"
import script from "./Idc.vue?vue&type=script&lang=js&"
export * from "./Idc.vue?vue&type=script&lang=js&"
import style0 from "./Idc.vue?vue&type=style&index=0&id=e9946b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9946b6e",
  null
  
)

component.options.__file = "Idc.vue"
export default component.exports